import React, { useState } from 'react';
import './join-modal-content.scss';
import JoinField from './JoinField';
import { getCallBackErrors } from '../util';
import JoinAreaField from './JoinAreaField';
import GBIButton from '../../../util/buttons/components/GBIButton';
import UserAPI from '../../UserAPI';
import LoadingIcon from '../../../util/icons/components/LoadingIcon';

const ArrangeCallBack = () => {
  const [ submitting, setSubmitting ] = useState(false);
  const [ apiError, setApiError ] = useState(null);
  const [ requestSent, setRequestSet ] = useState(false);
  const [ name, setName ] = useState('');
  const [ phone, setPhone ] = useState('');
  const [ email, setEmail ] = useState('');
  const [ message, setMessage ] = useState('');
  const [ errors, setErrors ] = useState({});
  const handleNameChange = name => {
    setName(name);
    setErrors(getCallBackErrors({ name, phone, email, message }));
  };
  const handleEmailChange = email => {
    setEmail(email);
    setErrors(getCallBackErrors({ name, phone, email, message }));
  };
  const handlePhoneChange = phone => {
    setPhone(phone);
    setErrors(getCallBackErrors({ name, phone, email, message }));
  };
  const handleMessageChange = message => {
    setMessage(message);
    setErrors(getCallBackErrors({ name, phone, email, message }));
  };
  const submit = () => {
    setSubmitting(true);
    UserAPI.requestCallback(name, email, phone, message).then(res => {
      setRequestSet(true);
      setSubmitting(false);
    }).catch(err => {
      setRequestSet(true);
      setSubmitting(false);
      setApiError(err.toString());
    });
  };
  if (requestSent && !apiError) {
    return (
      <div id="call-back-section">
        <p className="instruction-text" data-cy="call-back-response">
          { `Thanks! We've got your message and we'll be in touch.` }
        </p>
      </div>
    );
  } else if (apiError) {
    return (
      <div id="call-back-section">
        <p className="api-error" data-cy="call-back-api-error">
          { `Oops, something went wrong: ${apiError}` }
        </p>
      </div>
    );
  }
  let button = null;
  if (submitting) {
    button = <LoadingIcon />;
  } else if (!requestSent && Object.keys(errors).length < 1) {
    if (name && phone && email && message) {
      button =
        <GBIButton label="send" onClick={ submit } testId="send-button"/>;
    } else {
      button =
        <GBIButton className="disabled" label="send" onClick={ submit }/>;
    }
  }
  return (
    <div id="call-back-section">
      <p className="instruction-text" data-cy="call-back-instructions">
        { `Any questions? We'd love talk. Let us know when you're free
        and we'll give you a call.` }
      </p>
      <div className="inputs">
        <JoinField error={ errors.name }
          placeholder="name"
          handleChange={ handleNameChange }
          testId="name-field" />
        <JoinField error={ errors.email }
          placeholder="email"
          handleChange={ handleEmailChange }
          testId="email-field" />
        <JoinField error={ errors.phone }
          placeholder="phone"
          handleChange={ handlePhoneChange }
          testId="phone-field" />
        <JoinAreaField error={ errors.message }
          placeholder="when would you like us to call you"
          handleChange={ handleMessageChange }
          testId="message-field" />
      </div>
      <div className="button-row">
        { button }
      </div>
    </div>
  );
};

export default ArrangeCallBack;
